import React from "react";
import { Route } from "react-router-dom";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Spinner from "../components/common/spinner/Spinner";
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";

const ProtectedRoute = ({ component, role, ...args }) => {
  const history = useHistory();

  if (!role && role != undefined) {
    history.push("/not-found");
  }

  return (
    <>
      <Route
        component={withAuthenticationRequired(component, {
          onRedirecting: () => <Spinner />,
        })}
        {...args}
      />
    </>
  );
};

export default ProtectedRoute;
